import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  startTour: false,
  startStreetmixTour: false
}

const tourSlice = createSlice({
  name: 'tourSlice',
  initialState,
  reducers: {
    setStartAppTour(state, action) {
      state.startTour = action.payload
    },
    setStartStreetmixTour(state, action) {
      state.startStreetmixTour = action.payload
    }
  }
})

export const { setStartAppTour, setStartStreetmixTour } = tourSlice.actions
export default tourSlice.reducer
